<script>
  /* Copyright (c) 2020 Jacques Desodt */
  import ButtonBar from './footer/ButtonBar.svelte'
  import ClockWrapper from './clock/ClockWrapper.svelte'
  import TimeToolbar from './header/TimeToolbar.svelte'
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  export let options = {}
  export let date = new Date()
  /* Propagates the change date event */
  $: dispatch('change', date)
  /* Sets the defaults arguments */
  let defaults = {
    /* Global colors */
    bgColor: '#666',
    color: '#fff',
    /* Components CSS classes */
    buttonClassName: '',
		buttonBarClassName: '',
    clockClassName: '',
    timeClassName: '',
    /* Buttons labels */
    buttonNow: 'NOW',
    buttonOk: 'OK',
    buttonCancel: 'CANCEL',
    /* Options */
    hasButtons: false, // Shows/hides the footer buttons bar
    hasToolbar: true, // Shows/hides the header time toolbar
    is24h: false, // Toggles on AM/PM or 24h mode
    openTo: 'hours', // Starts by displaying the hours/minutes
    zIndex: 10
  }
  /* Sets the final arguments */
  let args = {...defaults, ...options}
  /* Sets the display pane choice */
  let hoursSelected = args.openTo === 'hours'
</script>

<div class="_tp-container">
{#if args.hasToolbar}
  <TimeToolbar {args} bind:date bind:hoursSelected />
{/if}
  <ClockWrapper {args} {hoursSelected} bind:date
    on:hourSelected={() => hoursSelected = false} /> <!-- goes to the minutes pane -->
{#if args.hasButtons}
   <ButtonBar {args} bind:date
    on:cancel
    on:ok={() => dispatch('ok', date)}
    />
{/if}
</div>

<style>
  ._tp-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 19rem;
  }
</style>
